import * as React from "react";
import { Button as BootstrapButton } from "reactstrap";
import "./MarbleButton.scss";

const buttonColors: { [key: string]: string } = {
  primary: "primary",
  secondary: "primary",
  danger: "danger",
  link: "link",
};

export const MarbleButton: React.FC<{
  type?: "primary" | "secondary" | "link" | "danger";
  isOutlined?: boolean;
  className?: string;
  size?: "sm" | "md" | "lg";
  isDisabled?: boolean;
  onClick: () => void;
}> = ({
  type = "primary",
  isOutlined = false,
  className = "",
  size = "md",
  isDisabled = false,
  onClick,
  children,
}) => {
  return (
    <BootstrapButton
      color={buttonColors[type]}
      outline={isOutlined || type === "secondary"}
      size={size}
      className={className}
      disabled={isDisabled}
      onClick={onClick}
    >
      <div className="children">{children}</div>
    </BootstrapButton>
  );
};
